import axios, { AxiosResponse } from "axios";
import { PeriodoAcademico, VoidPeriodoAcademico } from "../interfaces/SAAC/PeriodoAcademico";
import { ResponseApi } from "../types/ResponseApi";
import { EstudianteActivoT, VoidEstudianteActivo } from "../interfaces/SAAC/EstudianteActivo";
import { CatalogoInvestigador, VoidCatalogoInvestigador } from "../interfaces/SAAC/CatalogoInvestigador";

const localBack: string = process.env.REACT_APP_BACK || '';
//const localBack: string = 'http://192.168.253.6:8067';
const APICATALOGO: string = '/api/ConsultasAcademico';

const APICATALOGOINV: string = '/api/ConsultasInv';

export default class AcademicoService {

    async GetPeriodoAcademicoEnEjecucion(token: any): Promise<ResponseApi<PeriodoAcademico>> {
        try {
            const response1: AxiosResponse<ResponseApi<any>> = await axios.get(localBack + APICATALOGO + '/GetPeriodoEnCurso',
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            return response1.data;
        } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return {
                status: { isSuccessfully: false, messages: ['Error en la conexión a Api GetPeriodoEnCurso'] },
                operation: 0,
                statusCode: 500,
                count: 0,
                listData: [],
                data: VoidPeriodoAcademico(),
            };
        }
    }

    async GetCarreraActivaByMatricula(token: any,matricula: string,tipo: string): Promise<ResponseApi<EstudianteActivoT>> {
        try {
            const response1: AxiosResponse<ResponseApi<EstudianteActivoT>> = await axios.get(`${localBack + APICATALOGO}/GetCarreraActiva/${matricula}&${tipo}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            
            return response1.data;
        } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return {
                status: { isSuccessfully: false, messages: ['Error en la conexión a Api GetCarreraActivaByMatricula'] },
                operation: 0,
                statusCode: 500,
                count: 0,
                listData: [],
                data: VoidEstudianteActivo(),
            };
        }
    }


    async GetCatalogoInvestigadores(token: any, idperiodo: number, idproyecto: number, tipo: string): Promise<ResponseApi<CatalogoInvestigador>> {
        try {
            const response1: AxiosResponse<ResponseApi<CatalogoInvestigador>> = await axios.get(localBack + APICATALOGOINV + '/GetCatalogoInvestigadores/'+idperiodo+'&'+idproyecto+'&'+tipo,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
            //console.log(response1.data);        
            return response1.data;
        } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return {
                status: { isSuccessfully: false, messages: ['Error en la conexión a Api GetCatalogoProfesores'] },
                operation: 0,
                statusCode: 500,
                count: 0,
                listData: [],
                data: VoidCatalogoInvestigador(),
            };
        }
    }


}